import styled from "styled-components";
import { theme } from "../../../../constants/StyledComponents";

export const StyledPerformanceChart = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;

  & .chart-body {
    flex: 1;
    min-height: 0;
    position: relative;
  }

  & svg:focus,
  & svg:focus-visible,
  & .recharts-wrapper:focus,
  & .recharts-wrapper *:focus {
    outline: none;
  }

  & svg:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.purple_2};
    outline-offset: 2px;
  }
`;

export const LabelsRowWrapper = styled.div`
  width: 100%;
  padding-left: 7%;
  padding-right: 5%;
  box-sizing: border-box;
`;

export const ImpactLabelsRow = styled.div`
  display: flex;
  width: 100%;
`;

export const ImpactLabelGroup = styled.div`
  flex: 8;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LineGroup = styled.div`
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border: 1px solid #0e0e0e;
  border-top: transparent;
  width: 100%;
  height: 20px;
`;

export const StyledThresholdsLegend = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 20px;
`;

export const ImpactGroupGap = styled.div`
  flex: 1;
`;

export const TooltipPositioner = styled.div<{ $x: number; $y: number }>`
  position: absolute;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
  pointer-events: none;
`;

export const StyledChartTooltip = styled.div`
  position: relative;
  transform: translate(calc(-100% + 4px), -50%);
  background-color: ${theme.colors.white};
  box-shadow: 0px 2px 8px 0px ${theme.colors.grey_1}33;
  padding: 6px 12px;
  border-radius: 6px;
  text-align: center;
`;

export const TooltipValue = styled.span`
  display: block;
  font-size: ${theme.variables.fs_14};
  font-weight: ${theme.variables.fw_semiBold};
  color: ${theme.colors.black};
`;

export const ChartTooltipArrow = styled.div`
  position: absolute;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 7px solid ${theme.colors.white};
`;
